<script lang="ts" setup>
const props = defineProps<{
  title: string;
  subtitle?: string;
  imageSrc?: string;
  videoSrc?: string;
  inline?: boolean;
}>();
</script>

<template>
  <div :class="['empty-state', { inline: props.inline }]">
    <video
      v-if="props.videoSrc"
      autoplay
      muted
      loop
      playsinline
      class="message-animation"
    >
      <source :src="props.videoSrc" type="video/webm" />
    </video>
    <img v-if="props.imageSrc" :src="props.imageSrc" alt="Empty State Image" />
    <h4>{{ props.title }}</h4>
    <p v-if="props.subtitle" class="typeface-small">{{ props.subtitle }}</p>
    <slot />
  </div>
</template>

<style lang="postcss" scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--color-slate-500);
  max-width: 100%;
  text-align: center;
  width: 100%;
  height: 100%;
  margin: 0 auto 2rem 0;
}

.empty-state.inline {
  margin: 1rem 0;
}

.message-animation {
  width: 130px;
  opacity: 0.8;
}

img {
  max-width: 12rem;
  margin: 1rem auto;
}

h4 {
  margin: 0.25rem 0 0;
}

p {
  width: 20rem;
  margin: 0.75rem 0 1rem;
  line-height: 1.25 !important;
}
</style>
